import {
  CompanyPublicSettings,
  ICompanyServicePlan,
} from "modules/company/types";
import { isAgencyWhiteLabellingEnabled } from "modules/companyPlanSettings/utils/whitelabel";

export const isCustomDomainEnabled = (
  eventCompanySettings?: CompanyPublicSettings,
  eventCompanyPlan?: ICompanyServicePlan | null,
) => {
  if (!eventCompanySettings || !eventCompanyPlan) {
    return false;
  }

  return (
    Boolean(eventCompanySettings.customDomain) &&
    eventCompanySettings.isCustomDomainVerified &&
    eventCompanySettings.enableAgencyWhiteLabelling &&
    isAgencyWhiteLabellingEnabled(eventCompanyPlan)
  );
};
